import React from 'react';
import { CardCarouselElement } from './card-carousel.types';
import { DefaultCard } from './cards/default-card';
import { ImageCard } from './cards/image-card';
import { NewsCard } from './cards/news-card';

interface CardItemProps {
  card: CardCarouselElement;
  cardType?: string;
  className?: string;
  priority?: boolean;
  /** Fully-built data-track-id for this card's link (e.g. "card-carousel-147-card-2"). */
  trackId?: string;
}

export function CardItem({ card, cardType, className, priority, trackId }: CardItemProps) {
  switch (cardType) {
    case 'news':
      return <NewsCard card={card} className={className} priority={priority} trackId={trackId} />;
    case 'imageCard':
      return <ImageCard card={card} className={className} priority={priority} trackId={trackId} />;
    default:
      return <DefaultCard card={card} className={className} priority={priority} trackId={trackId} />;
  }
}
